export const formatPaperElapsed = (secs: number) => {
  const safe = Math.max(0, Math.floor(secs))
  const m = Math.floor(safe / 60)
  const s = safe % 60
  return m > 0 ? `${m}m ${s}s` : `${s}s`
}

export const formatPaperTimer = (secs: number) => {
  const safe = Math.max(0, Math.floor(secs))
  const m = Math.floor(safe / 60)
  const s = safe % 60
  return `${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`
}

export const formatPaperDate = (iso: string | null) => {
  if (!iso) return "—"
  return new Date(iso).toLocaleDateString("en-IE", {
    day: "numeric",
    month: "short",
    year: "numeric",
  })
}
